import { render } from "./CompanyEditView.vue?vue&type=template&id=a4d72794&scoped=true&ts=true"
import script from "./CompanyEditView.vue?vue&type=script&lang=ts"
export * from "./CompanyEditView.vue?vue&type=script&lang=ts"

import "./CompanyEditView.vue?vue&type=style&index=0&id=a4d72794&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d72794"]])

export default __exports__